import { Modal, Box, Card, CardContent, TextField, MenuItem, Button, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useState, useEffect } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleIcon from '@mui/icons-material/AddCircle';
// Custom Component
import AddEditLandRegistration from './AddEditLandRegistration';
// Custom Hooks
import useLandregistration from '../hooks/useLandregistration';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    // height: '50vh',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    '& .MuiTextField-root': { m: 1 }
};

export default function LandRegistrationInfoModal(props) {
    const { infoModalOpen, setInfoModalOpen, rowData } = props
    const [landData, setLandData] = useState({
        id: '',
        parcel_cod: '',
        old_parcel: ''
    })
    const [landRegistrationData, setLandRegistrationData] = useState([{
        id: '1',
        parcel_cod: '',
        old_parcel: ''
    }])
    // Add Edit
    const [addEditModalOpen, setAddEditModalOpen] = useState(false)
    const [rowId, setRowId] = useState()
    // Custom Hooks
    const { fetchLandData } = useLandregistration()
    const columns = [
        { field: 'id', headerName: 'ลำดับที่', width: 60 },
        {
            field: 'owner', headerName: 'เจ้าของปัจจุบัน', width: 200,
            renderCell: (params) => {
                const { owner_prefix, owner_firstname, owner_lastname } = params.row
                return owner_prefix || '' + owner_firstname + ' ' + owner_lastname
            }
        },
        {
            field: 'previous_owner', headerName: 'เจ้าของเดิม', width: 200,
            renderCell: (params) => {
                const { owner_prefix, owner_firstname, owner_lastname } = params.row
                return owner_prefix || '' + owner_firstname + ' ' + owner_lastname
            }
        },
        {
            field: 'dn', headerName: 'เลขที่เอกสารสิทธิ์', width: 150,
            renderCell: (params) => {
                return parseInt(params.row.previous_dn) || ''
            }
        },
        {
            field: 'previous_dn', headerName: 'เลขที่เอกสารสิทธิ์เดิม', width: 150,
            renderCell: (params) => {
                return parseInt(params.row.previous_dn) || ''
            }
        },
        {
            field: 'note', headerName: 'หมายเหตุ', width: 180,
            renderCell: (params) => {
                return parseInt(params.row.note) || ''
            }
        },
        // { field: 'land_area', headerName: 'เนื้อที่', width: 120 },
        {
            field: 'Button',
            headerName: '',
            sortable: false,
            width: 350,
            renderCell: (params) => {
                const id = params.row.id
                return (
                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<InfoIcon />}
                        // onClick={() => {
                        //     setRowId(id)
                        //     setAddEditModalOpen(true)
                        // }}
                        >
                            ดูข้อมูล
                        </Button>
                    </Box >
                )
            }
        }
    ]
    useEffect(() => {
        console.log(rowData)
        if (rowData === undefined) {
            // setDefaultWasteFeeData()
        } else {
            fetchLandData(setLandRegistrationData, rowData)
        }
    }, [rowData])
    return (
        <Modal
            open={infoModalOpen}
            onClose={() => {
                setInfoModalOpen(false)
                // setDefaultWasteFeeData()
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={style}
                component='form'
            // onSubmit={(event) => {
            //     if (rowId === undefined) {
            //         addWasteFeeData(wasteFeeData, setDefaultWasteFeeData, setAddModalOpen, setSuccessAlertOpen, setErrorAlertOpen, setSuccessText, setErrorText)
            //     } else {
            //         editWasteFeeData(wasteFeeData, setDefaultWasteFeeData, setAddModalOpen, setSuccessAlertOpen, setErrorAlertOpen, setSuccessText, setErrorText, rowId)
            //     }
            //     axiosWasteFeeDataList(setWasteFeeDataList)
            //     console.log('first')
            // }}
            >
                <Card>
                    <CardContent>
                        <Typography>รหัสแปลงที่ดิน : {rowData?.parcel_cod}</Typography>
                        <Typography>รหัสแปลงที่ดินเก่า : {rowData?.old_parcel}</Typography>
                        <Typography>เลขที่โฉนด : {parseInt(rowData?.dn)}</Typography>
                        <Typography>ระวาง : {parseInt(rowData?.utmmap1) + '-' + parseInt(rowData?.utmmap2) + '-' + rowData?.utmmap3 + '-' + rowData?.utmmap4}</Typography>
                    </CardContent>
                    <CardContent style={{ height: 350, width: '100%' }}>
                        <Typography>ข้อมูลการเปลี่ยนแปลงที่ดิน</Typography>
                        <DataGrid
                            rows={landRegistrationData}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                        />
                    </CardContent>
                    <CardContent>
                        <Button
                            sx={{ marginLeft: '1ch' }}
                            variant='contained'
                            color='success'
                            startIcon={<AddCircleIcon />}
                            onClick={() => {
                                setAddEditModalOpen(true)
                                // setDefaultWasteFeeData()
                            }}
                        >
                            เพิ่ม
                        </Button>
                    </CardContent>
                </Card>
                <AddEditLandRegistration
                    rowId={rowId}
                    addEditModalOpen={addEditModalOpen}
                    setAddEditModalOpen={setAddEditModalOpen}
                />
            </Box>
        </Modal>
    )
}
